import VolleyballScoreboard from "./volleyball/VolleyballScoreboard";
import BasketballScoreboard from "./basketball/BasketballScoreboard";
import FootballScoreboard from "./football/FootballScoreboard";
import BadmintonScoreboard from "./badminton/BadmintonScoreboard";
import TableTennisScoreboard from "./tabletennis/TableTennisScoreboard";
import { getSportConfigKey } from "../../../config/sportsConfig";

const BOARDS = {
  volleyball: VolleyballScoreboard, // indoor and beach volleyball
  basketball: BasketballScoreboard,
  football: FootballScoreboard, // football / soccer
  badminton: BadmintonScoreboard, // singles and doubles
  tabletennis: TableTennisScoreboard,
};

/**
 * The dedicated board for a sport, or null (generic board). The sport is
 * resolved with getSportConfigKey, like the rules and advanced scoring (LS-B15).
 */
export const getSportScoreboardComponent = (sportName) => {
  const key = getSportConfigKey(sportName);
  return (key && BOARDS[key]) || null;
};
